// react + dependencies
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
// components
import PricelistComponent from "../components/cenik/PricelistComponent";

const Cenik = () => {
  const top = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <Helmet>
        <title>Ceník fotografování - Kavalier Photography</title>
        <meta
          name="description"
          content="Ceník rodinného, svatebního a reportážního fotografování. Profesionální fotoslužby v Českém Ráji a okolí. Transparentní ceny bez skrytých poplatků."
        />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.kavalierphotographer.cz/cenik"
        />
        <meta
          property="og:title"
          content="Ceník fotografování - Kavalier Photography"
        />
        <meta
          property="og:description"
          content="Ceník rodinného, svatebního a reportážního fotografování. Profesionální fotoslužby v Českém Ráji a okolí."
        />
        <meta
          property="og:image"
          content="https://www.kavalierphotographer.cz/assets/logo/AK_black.webp"
        />
        <meta
          property="og:image:alt"
          content="Kavalier Photography - AK Logo"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.kavalierphotographer.cz/cenik"
        />
        <meta
          property="twitter:title"
          content="Ceník fotografování - Kavalier Photography"
        />
        <meta
          property="twitter:description"
          content="Ceník rodinného, svatebního a reportážního fotografování. Profesionální fotoslužby v Českém Ráji."
        />
        <meta
          property="twitter:image"
          content="https://www.kavalierphotographer.cz/assets/logo/AK_black.webp"
        />

        <link
          rel="canonical"
          href="https://www.kavalierphotographer.cz/cenik"
        />
      </Helmet>

      <section className="w-full my-0 md:my-10">
        <div className={`w-full`}>
          <div className="h-full container flex flex-col md:flex-row items-start justify-between">
            {/* left */}
            <div className="w-full md:w-4/12 relative md:sticky top-0 pt-0 md:pt-6">
              <div className="pl-0 mr-0 md:mr-10 pt-6 md:pt-10 border-t border-[var(--cerna)]">
                <div>
                  <h3 className="text-3xl font-bold mb-4">ceník</h3>
                  <p className="hidden md:block">
                    Zaujala vás nějaká ze služeb nebo se chcete jen nezávazně
                    poradit?
                  </p>
                </div>
                <div className="mt-4 hidden md:block">
                  <Link to="/kontakt">
                    <button className="btn-primary">napište mi</button>
                  </Link>
                </div>
              </div>
            </div>

            {/* right */}
            <div className="w-full md:w-8/12 mt-6 md:mt-0 mb-20">
              <div className="w-full md:w-10/12 m-auto">
                <PricelistComponent />
                <div className="text-start">
                  <p className="font-light italic text-xs mt-0">
                    ceník může podléhat změnám a nemusí být stoprocentně
                    aktuální
                  </p>
                </div>
                <div className="mt-4 block md:hidden">
                  <p className="">
                    Zaujala vás nějaká ze služeb nebo se chcete jen nezávazně
                    poradit?
                  </p>
                  <div className="mt-4">
                    <Link to="/kontakt" onClick={top}>
                      <button className="btn-primary">napište mi</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Cenik;
